import React from "react";
import Contacts from "./Contacts";
import Locations from "./Locations";

const ContactsPage = () => {
  return (
    <>
      <Locations />
      <Contacts />
    </>
  );
};

export default ContactsPage;
